import React, {useState, useEffect} from 'react';
import axios from 'axios';
import {useHistory, Route, Redirect} from 'react-router-dom';

function MuseumPost(){
    
    const [name, setName] = useState('');
    const [status, setStatus] = useState('');
    const [address1, setAddress1] = useState('');
    const [address2, setAddress2] = useState('');
    const [genre, setGenre] = useState('');
    const [opening_hours, setOpening_hours] = useState('');
    const [closing_days, setClosing_days] = useState('');
    const [tickets, setTickets] = useState('');
    const [website, setWebsite] = useState('');
    const [longitude, setLongitude] = useState('');
    const [latitude, setLatitude] = useState('');
    const [image, setImage] = useState('');
    const [image_copyright, setImage_copyright] = useState('');
    const [isOpenMonday, setIsOpenMonday] = useState('');
    const [isFreeAdmission, setIsFreeAdmission] = useState('');
    const [isRecommendation, setIsRecommendation] = useState('');


    const history = useHistory();
  
    function handleSubmit(event){
        event.preventDefault();
     
        axios.post('/api/museums_upload', {
           name, status, address1, address2, genre, opening_hours, closing_days, tickets, website, longitude, latitude, image, image_copyright, isOpenMonday, isFreeAdmission, isRecommendation

        })
        .then(response=>{
            history.push('/museums')
        })
        .catch(error=>{
            console.log(error)
        })
    }

    const genreList =['Contemporary art', 'Modern art', 'Classic art', 'Ancient art', 'Applied fine arts', 'Photograph']

    const genreOptions = genreList.map(genre =>{
        return(
            <option key={genre} value={genre}>
                {genre}
            </option>
        )
    })

    const statusList =['Open', 'Close']

    const statusOptions = statusList.map(status =>{
        return(
            <option key={status} value={status}>
                {status}
            </option>
        )
    })

    const openMondayList =['Yes', 'No']

    const openMondayOptions = openMondayList.map(status =>{
        return(
            <option key={status} value={status}>
                {status}
            </option>
        )
    })

    const freeAdmissionList =['Yes', 'No']

    const freeAdmissioOptions = freeAdmissionList.map(status =>{
        return(
            <option key={status} value={status}>
                {status}
            </option>
        )
    })

    const recommedationList =['Yes', 'No']

    const recommedationOptions = recommedationList.map(isRecommendation =>{
        return(
            <option key={isRecommendation} value={isRecommendation}>
                {isRecommendation}
            </option>
        )
    })


    return(
        <div className='museum_post'>
            <form method='POST' onSubmit={handleSubmit}>
                <div className='admin_post_flex'>
                <label className='label_block'>Name:</label>
                <input type='text' id='name' name='name' placeholder='name of museum' value={name} onChange={e=>setName(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Genre:</label>
                <select id='genre' name='genre' value={genre} onChange={e=>setGenre(e.target.value)}>
                <option hidden value=''>
                    Select genre
                </option>
                {genreOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label  className='label_block'>Open Status:</label>
                <select id='status' name='status' value={status} onChange={e=>setStatus(e.target.value)}>
                <option hidden value=''>
                    Select Open Status
                </option>
                {statusOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Street:</label>
                <input type='text' id='address1' name='address1' placeholder='address of museum' value={address1} onChange={e=>setAddress1(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>City and Postal Code:</label>
                <input type='text' id='address2' name='address2' placeholder='city name of address of museum' value={address2} onChange={e=>setAddress2(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Opening Hours:</label>
                <input type='text' id='opening_hours' name='opening_hours' placeholder='opening hours' value={opening_hours} onChange={e=>setOpening_hours(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Closing Days:</label>
                <input type='text' id='closing_days' name='closing_days' placeholder='closing days' value={closing_days} onChange={e=>setClosing_days(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Tickets Fee:</label>
                <input type='text' id='tickets' name='tickets' placeholder='tickets' value={tickets} onChange={e=>setTickets(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Web-Site:</label>
                <input type='text' id='web-site' name='web-site' placeholder='Web-Site' value={website} onChange={e=>setWebsite(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Longitude:</label>
                <input type='text' id='longitude' name='longitude' placeholder='Longitude' value={longitude} onChange={e=>setLongitude(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label  className='label_block'>Latitude:</label>
                <input type='text' id='latitude' name='latitude' placeholder='Latitude' value={latitude} onChange={e=>setLatitude(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Image Url:</label>
                <input type='text' id='image' name='image' placeholder='image' value={image} onChange={e=>setImage(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Image Copyright:</label>
                <input type='text' id='image-copyright' name='image-copyright' placeholder='image-copyright' value={image_copyright} onChange={e=>setImage_copyright(e.target.value)}/>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Is Open Monday? :</label>
                <select id='isOpenMonday' name='isOpenMonday' value={isOpenMonday} onChange={e=>setIsOpenMonday(e.target.value)}>
                <option hidden value=''>
                    Select Status
                </option>
                {openMondayOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label className='label_block'>Is Free Admission? :</label>
                <select id='isFreeAdmission' name='isFreeAdmission' value={isFreeAdmission} onChange={e=>setIsFreeAdmission(e.target.value)}>
                <option hidden value=''>
                    Select Status
                </option>
                {freeAdmissioOptions}
                </select>
                </div>

                <div className='admin_post_flex'>
                <label  className='label_block'>Is Your Recommendation? :</label>
                <select id='isRecommendation' name='isRecommendation' value={isRecommendation} onChange={e=>setIsRecommendation(e.target.value)}>
                <option hidden value=''>
                    Select Status
                </option>
                {recommedationOptions}
                </select>
                </div>
  
                <input type='submit' value='Submit'/>
            </form>
        </div>
    )
}

export default MuseumPost;